import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let modules = {
	state: {
		orderType:false,
		boxShow:true
	},
	mutations: {
		changeOrderType(state,res) {
			state.orderType=!state.orderType
		},
		changeBoxShow(state,res) {
			state.boxShow=res
		}
	},
	actions: {}
};
const files = require.context("./modules", false, /\.js$/);
files.keys().forEach((key) => {
	Object.assign(modules.state, files(key)["state"]);
	Object.assign(modules.mutations, files(key)["mutations"]);
	Object.assign(modules.actions, files(key)["actions"]);
});
const store = new Vuex.Store(modules);
export default store